export default "__VITE_ASSET__BKQmDkgJ__"